<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Map Pin Filled" class="d-icon d-icon--map-pin-filled" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m6 11 .263.35v-.001l.004-.002.01-.008.036-.028.133-.105a16.107 16.107 0 0 0 1.881-1.79c1.01-1.137 2.11-2.743 2.11-4.416a4.438 4.438 0 0 0-8.874 0c0 1.673 1.1 3.28 2.11 4.416a16.107 16.107 0 0 0 2.014 1.895l.023.018.013.01.01.008.003.002h.001L6 11Zm0 0-.263.35c.156.117.37.117.526 0L6 11Zm0-7.063a1.063 1.063 0 1 1 0 2.126 1.063 1.063 0 0 1 0-2.125ZM7.938 5a1.938 1.938 0 1 0-3.876 0 1.938 1.938 0 0 0 3.875 0Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMapPinFilled',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
